import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import { CircularProgress, IconButton } from '@mui/material';
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import _ from "lodash";
import React, { useEffect, useState } from "react";
import ActivityRow from './activity.row';
import { enrollmentApi } from "./enrollment.queries";

const CHUNK_SIZE = 25;

function ActivityTable(props) {
	const fetchData = !props.enrollment?.activities?.length;
	const useGet = enrollmentApi.useGet(props.id ?? props.enrollment?.id, { enabled: fetchData });
	const enrollment = fetchData ? useGet?.data : props.enrollment;
	const [expandAll, setExpandAll] = useState(null);

	let activities = enrollment?.activities;

	const [visibleCount, setVisibleCount] = useState(CHUNK_SIZE);

	//Force "null" instead of "undefined"
	_.forEach(activities, activity => {
		activity.courseDetail = activity.courseDetail ?? {};
		activity.courseDetail.parentId = activity?.courseDetail?.parentId ?? null;
	});
	const groups = _.groupBy(activities, 'courseDetail.parentId');
	const rows = _.sortBy(groups?.['null'], 'courseDetail.ordinal');
	const visibleRows = _.slice(rows, 0, visibleCount);

	useEffect(() => {
		if (visibleCount >= rows.length) {
			return;
		}

		const loadMore = () => {
			setVisibleCount((prev) => Math.min(prev + CHUNK_SIZE, rows.length));
		};

		const idleCallback = () => {
			loadMore();
			if ((visibleCount + CHUNK_SIZE) < rows.length) {
				requestIdleCallback(idleCallback);
			}
		};

		requestIdleCallback(idleCallback);
	}, [visibleCount, rows.length]);

	if (!activities) {
		return;
	}

	if (enrollment) {
		let clone = _.omit(enrollment, 'activities');
		activities.forEach(activity => activity.enrollment = clone);
	}

	//Removes activities where enrollment was deleted
	activities = _.filter(activities, 'enrollment');
	if (!activities.length) {
		return;
	}

	if (!groups) {
		//setGroups(_.groupBy(activities, 'courseDetail.parentId'));
	}

	return (
		<TableContainer component={Paper} sx={{ pb: 2, overflow: 'visible' }}>
			<Table>
				<TableHead>
					<TableRow>
						<TableCell>
							<IconButton onClick={() => setExpandAll(!expandAll)}>
								{expandAll ? <KeyboardArrowUpIcon fontSize="inherit" /> : <KeyboardArrowDownIcon fontSize="inherit" />}
							</IconButton>
						</TableCell>
						<TableCell>Status</TableCell>
						<TableCell>Activity</TableCell>
						<TableCell>Start Date</TableCell>
						<TableCell>End Date</TableCell>
						{/* <TableCell>Due Date</TableCell> */}
						<TableCell sx={{pl:3}}>Score</TableCell>
						<TableCell>Progress</TableCell>
						<TableCell>More</TableCell>
					</TableRow>
				</TableHead>
				<TableBody>
					{visibleRows.length > 0 && visibleRows.map(activity =>
						<ActivityRow activity={activity} groups={groups} depth={0} key={activity.id} expandAll={expandAll} />
					)}
					{visibleRows?.length < rows?.length &&
						<TableRow>
							<TableCell colSpan={6} sx={{ py: 2, textAlign: 'center' }}>
								<CircularProgress size={20} />
							</TableCell>
						</TableRow>
					}
				</TableBody>
			</Table>
		</TableContainer>
	);
}

export default React.memo(ActivityTable);